import { ConnectButton } from "@rainbow-me/rainbowkit";
import React, { useContext, useEffect, useState } from "react";
import { ProjectContext } from "../../ProjectContext";
import { useNavigate } from "react-router-dom";

function Header2() {
  const { account, dbuser, setdbuser, Refaddress } = useContext(ProjectContext);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (dbuser?.address.toLowerCase() === account?.toLowerCase()) {
  //     navigate("/");
  //   } else {
  //     navigate("/dashboard");
  //   }
  // }, [dbuser, navigate, Refaddress]);

  // useEffect(() => {
  //   if (!account) {
  //     setdbuser(null);
  //   }
  // }, [account, setdbuser]);
  return (
    <>
      <div>
        {" "}
        <div className="container">
          <div className="navbar-main-se mt-3 index-page-navbar container ">
            <div className="">
              <nav className="d-flex justify-content-between ">
                <a className="navbar-brand" href="#">
                  <img
                    src="../assets/images/logo/logo-light.svg"
                    width={150}
                    alt="logo"
                  />
                </a>
                {/* <button className="button-1 px-4 px-md-5 ">
                  <div className="dots_border" />
                  <img
                    src="../assets/images/lock-icon.png"
                    className="sparkle img-fluid"
                    alt="lock-icon"
                  />
                  <span className="text_button">Login</span>
                </button> */}
                <ConnectButton />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header2;
